import { Helmet } from "react-helmet";
import { Button, Heading, Img } from "../../components";
import VerifiedContentWithStatistics from "../../components/VerifiedContentWithStatistics";
import React, { Suspense } from "react";

const verifiedContentList = [
  {
    verificationText: "Verified by Suplyd",
    titleText: (
      <>
        How To Create Restaurant P&L Trend
        <br />
        Analysis?
      </>
    ),
    descriptionText:
      "A Profit and Loss Statement is one of the most important financial tools that a restaurant owner has to evaluate their operation in detail....",
    likeCount: "30",
    contrastCount: "50",
    downloadCount: "50",
    priceText: "300 EGP",
  },
  {
    verificationText: "Verified by Suplyd",
    titleText: (
      <>
        How To Create Restaurant P&L Trend
        <br />
        Analysis?
      </>
    ),
    descriptionText:
      "A Profit and Loss Statement is one of the most important financial tools that a restaurant owner has to evaluate their operation in detail....",
    likeCount: "30",
    contrastCount: "50",
    downloadCount: "50",
    priceText: "300 EGP",
  },
  {
    verificationText: "Verified by Suplyd",
    titleText: (
      <>
        How To Create Restaurant P&L Trend
        <br />
        Analysis?
      </>
    ),
    descriptionText:
      "A Profit and Loss Statement is one of the most important financial tools that a restaurant owner has to evaluate their operation in detail....",
    likeCount: "30",
    contrastCount: "50",
    downloadCount: "50",
    priceText: "300 EGP",
  },
];

export default function EventsListOnePage() {
  return (
    <>
      <Helmet>
        <title>Restaurant Case Studies - P&L Trend Analysis</title>
        <meta
          name="description"
          content="Dive into our case studies on creating a Profit and Loss Statement trend analysis for restaurants. Gain verified insights and strategies to enhance your financial growth and operational efficiency."
        />
      </Helmet>
      <div className="w-full overflow-x-scroll bg-gray-50 py-[46px] md:py-5 sm:py-4">
        <div className="mb-[592px] flex flex-col gap-7">
          <header className="flex flex-col items-center gap-[18px]">
            <div className="flex self-stretch bg-white-a700">
              <div className="container-sm flex pl-[566px] pr-14 lg:px-5 md:px-5">
                <div className="flex w-[28%] items-start justify-between gap-5 lg:w-full md:w-full sm:items-center sm:justify-center">
                  <div className="flex flex-col items-center self-center p-1">
                    <a href="#">
                      <Button className="flex h-[40px] w-[40px] items-center justify-center rounded-[20px] px-2">
                        <Img src="images/img_arrow_left.svg" />
                      </Button>
                    </a>
                  </div>
                  <Heading
                    size="heading2xl"
                    as="h5"
                    className="mt-2 !font-abhayalibreextrabold text-[22px] font-extrabold !text-gray-900_04 lg:text-[18px] sm:text-[24px]"
                  >
                    Case Studies
                  </Heading>
                </div>
              </div>
            </div>
            <div className="container-sm flex flex-col items-center px-14 lg:px-5 md:px-5 sm:flex-row">
              <div className="flex w-[28%] justify-center gap-2 lg:w-full md:w-full sm:flex-row">
                <Button className="flex h-[32px] min-w-[40px] flex-row items-center justify-center rounded-[16px] bg-deep_orange-50_01 px-3 text-center text-[14px] tracking-[0.10px] text-deep_orange-500">
                  All
                </Button>
                <Button className="flex h-[32px] flex-1 flex-row items-center justify-center rounded-[16px] border border-solid border-blue_gray-100 px-[11px] text-center text-[14px] tracking-[0.10px] text-gray-700 sm:self-stretch">
                  Financial
                </Button>
                <Button className="flex h-[32px] flex-1 flex-row items-center justify-center rounded-[16px] border border-solid border-blue_gray-100 px-[11px] text-center text-[14px] tracking-[0.10px] text-gray-700 sm:self-stretch">
                  Growth
                </Button>
                <Button className="flex h-[32px] flex-1 flex-row items-center justify-center rounded-[16px] border border-solid border-blue_gray-100 px-[11px] text-center text-[14px] tracking-[0.10px] text-gray-700 sm:self-stretch">
                  Marketing
                </Button>
                <Button className="flex h-[32px] flex-1 flex-row items-center justify-center rounded-[16px] border border-solid border-blue_gray-100 px-[11px] text-center text-[14px] tracking-[0.10px] text-gray-700 sm:self-stretch">
                  Marketing
                </Button>
              </div>
            </div>
          </header>
          <div className="mr-[398px] flex gap-5 md:mr-0 md:flex-col sm:flex-row sm:overflow-x-scroll sm:p-2">
            <Suspense fallback={<div>Loading feed...</div>}>
              {verifiedContentList.map((d, index) => (
                <a href="https://www.youtube.com/embed/bv8Fxk0sz7I" target="_blank">
                  <VerifiedContentWithStatistics {...d} key={"eventsListOne" + index} />
                </a>
              ))}
            </Suspense>
          </div>
        </div>
      </div>
    </>
  );
}
